import { Box, styled } from '@mui/material';
import { progressContainerAnimations } from '../animations';
import { getProgressContainerStyles, getScrollbarHidingStyles } from '../utils';

// Container for the entire progress bar
export const ProgressContainer = styled(Box)(({ theme }) => ({
  ...getProgressContainerStyles(theme),
  ...getScrollbarHidingStyles(),
  ...progressContainerAnimations,
}));
